import { useState, memo } from "react";
import { ComposableMap, Geographies, Geography, Marker, ZoomableGroup } from "react-simple-maps";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { MapPin, IndianRupee, Box, Scale, ZoomIn, ZoomOut, Download } from "lucide-react";

const INDIA_TOPO_URL = "https://gist.githubusercontent.com/jbrobst/56c13bbbf9d97d187fea01ca62ea5112/raw/e388c4cae20aa53cb5090210a42ebb9b765c0a36/india_states.geojson";

const CITY_COORDS = {
  "mumbai": [72.8777, 19.0760], "delhi": [77.1025, 28.7041], "bangalore": [77.5946, 12.9716],
  "bengaluru": [77.5946, 12.9716], "hyderabad": [78.4867, 17.3850], "chennai": [80.2707, 13.0827],
  "kolkata": [88.3639, 22.5726], "pune": [73.8567, 18.5204], "ahmedabad": [72.5714, 23.0225],
  "jaipur": [75.7873, 26.9124], "lucknow": [80.9462, 26.8467], "kanpur": [80.3318, 26.4499],
  "nagpur": [79.0882, 21.1458], "indore": [75.8577, 22.7196], "thane": [72.9781, 19.2183],
  "bhopal": [77.4126, 23.2599], "visakhapatnam": [83.2185, 17.6868], "patna": [85.1376, 25.6093],
  "vadodara": [73.1812, 22.3072], "ghaziabad": [77.4538, 28.6692], "ludhiana": [75.8573, 30.9010],
  "agra": [78.0081, 27.1767], "nashik": [73.7898, 19.9975], "ranchi": [85.3096, 23.3441],
  "faridabad": [77.3178, 28.4089], "meerut": [77.7064, 28.9845], "rajkot": [70.8022, 22.3039],
  "varanasi": [83.0007, 25.3176], "srinagar": [74.7973, 34.0837], "aurangabad": [75.3433, 19.8762],
  "dhanbad": [86.4304, 23.7957], "amritsar": [74.8723, 31.6340], "allahabad": [81.8463, 25.4358],
  "prayagraj": [81.8463, 25.4358], "howrah": [88.2636, 22.5958], "coimbatore": [76.9558, 11.0168],
  "jabalpur": [79.9864, 23.1815], "gwalior": [78.1828, 26.2183], "vijayawada": [80.6480, 16.5062],
  "jodhpur": [73.0243, 26.2389], "madurai": [78.1198, 9.9252], "raipur": [81.6296, 21.2514],
  "kota": [75.8648, 25.2138], "guwahati": [91.7362, 26.1445], "chandigarh": [76.7794, 30.7333],
  "solapur": [75.9064, 17.6599], "hubli": [75.1240, 15.3647], "mysore": [76.6394, 12.2958],
  "mysuru": [76.6394, 12.2958], "tiruchirappalli": [78.6569, 10.7905], "bareilly": [79.4304, 28.3670],
  "aligarh": [78.0880, 27.8974], "tiruppur": [77.3411, 11.1085], "moradabad": [78.7733, 28.8386],
  "jalandhar": [75.5762, 31.3260], "bhubaneswar": [85.8245, 20.2961], "salem": [78.1460, 11.6643],
  "warangal": [79.5941, 17.9784], "guntur": [80.4365, 16.3067], "bhiwandi": [73.0483, 19.2813],
  "saharanpur": [77.5510, 29.9680], "gorakhpur": [83.3732, 26.7606], "bikaner": [73.3119, 28.0229],
  "amravati": [77.7523, 20.9320], "noida": [77.3910, 28.5355], "jamshedpur": [86.1853, 22.8046],
  "bhilai": [81.3509, 21.2094], "cuttack": [85.8830, 20.4625], "firozabad": [78.3957, 27.1591],
  "kochi": [76.2673, 9.9312], "ernakulam": [76.2673, 9.9312], "nellore": [79.9865, 14.4426],
  "bhavnagar": [72.1519, 21.7645], "dehradun": [78.0322, 30.3165], "durgapur": [87.3119, 23.5204],
  "asansol": [86.9524, 23.6739], "rourkela": [84.8536, 22.2604], "nanded": [77.3209, 19.1383],
  "kolhapur": [74.2433, 16.7050], "ajmer": [74.6399, 26.4499], "gulbarga": [76.8343, 17.3297],
  "kalaburagi": [76.8343, 17.3297], "loni": [77.2867, 28.7509], "jamnagar": [70.0577, 22.4707],
  "ujjain": [75.7885, 23.1793], "siliguri": [88.4275, 26.7271], "jhansi": [78.5685, 25.4484],
  "ulhasnagar": [73.1631, 19.2183], "navi mumbai": [73.0169, 19.0330], "jammu": [74.8570, 32.7266],
  "sangli": [74.5815, 16.8524], "mangalore": [74.8560, 12.9141], "erode": [77.7172, 11.3410],
  "belgaum": [74.4977, 15.8497], "belagavi": [74.4977, 15.8497], "ambattur": [80.1548, 13.0987],
  "tirunelveli": [77.7264, 8.7139], "malegaon": [74.5479, 20.5548], "gaya": [84.9994, 24.7955],
  "udaipur": [73.7125, 24.5854], "kakinada": [82.2475, 16.9891], "davanagere": [75.9218, 14.4644],
  "kozhikode": [75.7804, 11.2588], "calicut": [75.7804, 11.2588], "akola": [77.0082, 20.7002],
  "kurnool": [78.0373, 15.8281], "bokaro": [85.9700, 23.6693], "rajahmundry": [81.8040, 17.0005],
  "ballari": [76.9214, 15.1394], "bellary": [76.9214, 15.1394], "agartala": [91.2868, 23.8315],
  "bhagalpur": [86.9842, 25.2425], "latur": [76.5604, 18.4088], "dhule": [74.7749, 20.9042],
  "korba": [82.6930, 22.3595], "bhilwara": [74.6313, 25.3407], "brahmapur": [84.7941, 19.3150],
  "muzaffarpur": [85.3910, 26.1209], "ahmednagar": [74.7479, 19.0948], "mathura": [77.6737, 27.4924],
  "kollam": [76.6141, 8.8932], "avadi": [80.1010, 13.1067], "kadapa": [78.8242, 14.4674],
  "anantapur": [77.5995, 14.6819], "kamarhati": [88.3700, 22.6700], "bilaspur": [82.1409, 22.0797],
  "sambalpur": [83.9812, 21.4669], "shimla": [77.1734, 31.1048], "aluva": [76.3534, 10.1004],
  "hoskote": [77.7981, 13.0707], "greater thane": [72.9781, 19.2183],
  "thrissur": [76.2144, 10.5276], "thiruvananthapuram": [76.9366, 8.5241],
  "trivandrum": [76.9366, 8.5241], "palakkad": [76.6548, 10.7867],
  "new delhi": [77.2090, 28.6139], "gurugram": [77.0266, 28.4595], "gurgaon": [77.0266, 28.4595],
};

const getCoords = (cityName) => {
  if (!cityName) return null;
  const key = cityName.toLowerCase().trim();
  if (CITY_COORDS[key]) return CITY_COORDS[key];
  for (const [k, v] of Object.entries(CITY_COORDS)) {
    if (key.includes(k) || k.includes(key)) return v;
  }
  return null;
};

const IndiaDeliveryMap = memo(({ cityData }) => {
  const [tooltip, setTooltip] = useState(null);
  const [zoom, setZoom] = useState(1);
  const [center, setCenter] = useState([82, 22]);

  if (!cityData || cityData.length === 0) return null;

  const maxOrders = Math.max(...cityData.map(c => c.orders), 1);
  const sortedCities = [...cityData].sort((a, b) => b.orders - a.orders);

  const handleZoomIn = () => setZoom(z => Math.min(z * 1.5, 8));
  const handleZoomOut = () => setZoom(z => Math.max(z / 1.5, 1));
  const handleMoveEnd = (position) => {
    setZoom(position.zoom);
    setCenter(position.coordinates);
  };

  const handleExportCSV = () => {
    const headers = ["Rank", "City", "Orders", "Invoice Amount", "Boxes", "Weight (kg)"];
    const rows = sortedCities.map((c, i) => [i + 1, c.city, c.orders, c.invoice_amount, c.boxes, c.weight_kg]);
    const csv = [headers, ...rows].map(r => r.map(v => `"${v}"`).join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `city_delivery_stats_${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Card className="border-0 shadow-lg" data-testid="india-delivery-map">
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2">
          <MapPin className="w-4 h-4" style={{ color: '#00A699' }} />
          Delivery Distribution - City View
          <span className="text-xs text-slate-400 font-normal ml-auto">{cityData.length} cities</span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          {/* Map - 2/3 width */}
          <div className="lg:col-span-2 relative rounded-lg border border-slate-100 overflow-hidden" style={{ height: 480 }}>
            {/* Zoom controls */}
            <div className="absolute top-3 right-3 z-10 flex flex-col gap-1">
              <button
                onClick={handleZoomIn}
                className="w-8 h-8 bg-white border border-slate-200 rounded-md shadow-sm flex items-center justify-center hover:bg-slate-50 transition-colors"
                data-testid="map-zoom-in"
              >
                <ZoomIn className="w-4 h-4 text-slate-600" />
              </button>
              <button
                onClick={handleZoomOut}
                className="w-8 h-8 bg-white border border-slate-200 rounded-md shadow-sm flex items-center justify-center hover:bg-slate-50 transition-colors"
                data-testid="map-zoom-out"
              >
                <ZoomOut className="w-4 h-4 text-slate-600" />
              </button>
            </div>
            <ComposableMap
              projection="geoMercator"
              projectionConfig={{ scale: 1000, center: [82, 22] }}
              width={700}
              height={480}
              style={{ width: "100%", height: "100%" }}
            >
              <ZoomableGroup zoom={zoom} center={center} onMoveEnd={handleMoveEnd} minZoom={1} maxZoom={8}>
                <Geographies geography={INDIA_TOPO_URL}>
                  {({ geographies }) =>
                    geographies.map((geo) => (
                      <Geography
                        key={geo.rsmKey}
                        geography={geo}
                        fill="#e2e8f0"
                        stroke="#cbd5e1"
                        strokeWidth={0.5}
                        style={{ default: { outline: "none" }, hover: { fill: "#cbd5e1", outline: "none" }, pressed: { outline: "none" } }}
                      />
                    ))
                  }
                </Geographies>
                {cityData.map((city) => {
                  const coords = getCoords(city.city);
                  if (!coords) return null;
                  const radius = 4 + (city.orders / maxOrders) * 14;
                  return (
                    <Marker key={city.city} coordinates={coords}>
                      <circle
                        r={radius}
                        fill="rgba(0, 166, 153, 0.6)"
                        stroke="#00A699"
                        strokeWidth={1.5}
                        style={{ cursor: "pointer" }}
                        onMouseEnter={() => setTooltip(city)}
                        onMouseLeave={() => setTooltip(null)}
                        onClick={() => setTooltip(tooltip?.city === city.city ? null : city)}
                      />
                      {radius > 8 && (
                        <text
                          textAnchor="middle"
                          y={radius + 12}
                          style={{ fontSize: 8, fill: "#334155", fontWeight: 500, pointerEvents: "none" }}
                        >
                          {city.city}
                        </text>
                      )}
                    </Marker>
                  );
                })}
              </ZoomableGroup>
            </ComposableMap>

            {/* Tooltip overlay */}
            {tooltip && (
              <div className="absolute top-3 left-3 bg-white/95 backdrop-blur border border-slate-200 shadow-lg rounded-lg p-3 z-10 min-w-[200px]">
                <p className="font-semibold text-slate-800 text-sm mb-1.5 border-b pb-1">{tooltip.city} <span className="text-slate-400 font-normal text-xs">({tooltip.orders} orders)</span></p>
                <div className="space-y-1 text-xs">
                  <div className="flex justify-between gap-4">
                    <span className="text-slate-500">Invoice Amount</span>
                    <span className="font-medium text-slate-800">₹{tooltip.invoice_amount.toLocaleString()}</span>
                  </div>
                  <div className="flex justify-between gap-4">
                    <span className="text-slate-500">Boxes</span>
                    <span className="font-medium text-slate-800">{tooltip.boxes.toLocaleString()}</span>
                  </div>
                  <div className="flex justify-between gap-4">
                    <span className="text-slate-500">Weight</span>
                    <span className="font-medium text-slate-800">{tooltip.weight_kg.toLocaleString()} kg</span>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* City list - 1/3 width */}
          <div className="lg:col-span-1">
            <div className="flex items-center justify-between mb-2 px-1">
              <span className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Top Cities by Orders</span>
              <button
                onClick={handleExportCSV}
                className="flex items-center gap-1 text-xs text-teal-600 hover:text-teal-700 transition-colors"
                data-testid="export-city-data"
              >
                <Download className="w-3.5 h-3.5" />
                Export
              </button>
            </div>
            <div className="overflow-y-auto border border-slate-100 rounded-lg" style={{ maxHeight: 448 }}>
              {sortedCities.map((city, i) => (
                <div
                  key={city.city}
                  className={`px-3 py-2.5 flex items-start gap-2 cursor-pointer transition-colors ${
                    tooltip?.city === city.city ? "bg-teal-50" : i % 2 === 0 ? "bg-white" : "bg-slate-50"
                  } hover:bg-teal-50`}
                  onMouseEnter={() => setTooltip(city)}
                  onMouseLeave={() => setTooltip(null)}
                >
                  <span className="text-xs font-bold text-slate-400 mt-0.5 w-5 text-right flex-shrink-0">{i + 1}</span>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between">
                      <span className="text-sm font-medium text-slate-800 truncate">{city.city}</span>
                      <span className="text-xs font-semibold text-teal-600 flex-shrink-0 ml-2">{city.orders}</span>
                    </div>
                    <div className="flex items-center gap-3 mt-0.5 text-xs text-slate-500">
                      <span className="flex items-center gap-0.5"><IndianRupee className="w-3 h-3" />{city.invoice_amount.toLocaleString()}</span>
                      <span className="flex items-center gap-0.5"><Box className="w-3 h-3" />{city.boxes}</span>
                      <span className="flex items-center gap-0.5"><Scale className="w-3 h-3" />{city.weight_kg} kg</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
});

export default IndiaDeliveryMap;
